<template>
  <div v-bind:class="printClass" v-bind:style="$root.printStyles" class="transition-all duration-100">

    <slot name="background">
    </slot>

    <div class="bleed" v-bind:style="bleedStyles">
      <!-- Layers in root? -->
      <rulers-layer v-if="rulers"></rulers-layer>

      <template v-for="(child, index) in $root.computedPrintConfig.layers">
        <component v-if="showmap || (showmap === false && child.name !== 'MapLayer')"
                   :is="child"
                   :key="child.name"></component>
      </template>

      <puzzle-overlay-layer v-if="!printmode && $root.print.material === 'puzzle'"></puzzle-overlay-layer>
    </div>
  </div>
</template>

<script>
import RulersLayer from "./layers/RulersLayer";
import PuzzleOverlayLayer from "./layers/PuzzleOverlayLayer";

export default {
  name: 'PrintLayers',
  components: {RulersLayer, PuzzleOverlayLayer},
  props: {
    bleedStyles: {},
    showmap: {
      type: Boolean,
      default: true
    },
    rulers: {
      type: Boolean,
      default: false
    },
    printmode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    printClass() {
      if (this.$root.type.includes('circle'))
        return 'print circle';

      return 'print';
    }
  }
}
</script>
<style scoped lang="scss">
.print {
  position: relative;
  z-index: 1;
  //overflow: hidden;
  display: inline-block;
  width: 100%;
  height: 100%;
  //background-color: white;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.25);
}

.circle {
  border-radius: 50%;
  overflow: hidden;
}

.bleed {
  height: 100%;
  width: 100%;
  position: relative;
  // border: solid rgba(255, 0, 0, 0.25);
}

</style>